import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import './subscription.scss';
import classNames from 'classnames';
import SubscriptionPresetPage from './SubscriptionPresetPage';
import SubscriptionListPage from './SubscriptionListPage';
import BlackListPage from './BlackWhites/BlackListPage';
import WhiteListPage from './BlackWhites/WhiteListPage';
import ModuleUnavailableState from '../../../components/base/ModuleUnavailableState';
import { getSystemData } from '../../System/reducer';
import { isServiceUnavailable, SERVICE_KEYS } from '../../System/serviceAvailability';
import { getClientData } from '../../Client/reducer';

export default function SubscriptionPage() {
  const [tab, setTab] = useState(1);
  const { serviceAvailability } = useSelector(getSystemData);
  const { clientData } = useSelector(getClientData);
  const isSubscriptionModuleUnavailable = isServiceUnavailable(serviceAvailability, SERVICE_KEYS.SUBSCRIPTION);
  const permissionKeys = clientData?.permissions?.map(permission => permission.name) || [];
  const hasBlackWhiteAccess = permissionKeys.includes('frontend_menu_black_white');
  const availableTabs = useMemo(() => (
    [
      { value: 1, label: 'Абонементы' },
      { value: 2, label: 'Пресеты' },
      ...(hasBlackWhiteAccess ? [
        { value: 3, label: 'Черный список' },
        { value: 4, label: 'Белый список' },
      ] : []),
    ]
  ), [hasBlackWhiteAccess]);

  useEffect(() => {
    if (!availableTabs.some(item => item.value === tab)) {
      setTab(availableTabs[0]?.value || 1);
    }
  }, [availableTabs, tab]);

  return (
    <div className="subscription-page page">
      <div className="tab-box">
        <div className="tab-menu">
          {availableTabs.map(item => (
            <div
              key={item.value}
              className={classNames('tab-item', { selected: tab === item.value })}
              onClick={() => setTab(item.value)}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>

      {tab === 1 ? (isSubscriptionModuleUnavailable ? <ModuleUnavailableState /> : <SubscriptionListPage />) : null}
      {tab === 2 ? (isSubscriptionModuleUnavailable ? <ModuleUnavailableState /> : <SubscriptionPresetPage />) : null}
      {tab === 3 && hasBlackWhiteAccess ? <BlackListPage /> : null}
      {tab === 4 && hasBlackWhiteAccess ? <WhiteListPage /> : null}
    </div>
  );
}
